module.exports = __webpack_public_path__ + "img/icon-24-gr.8594bcc2.svg";